import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CaseService } from '../../../shared/services/case.service';
import { CorrespondenceTimelineService } from 'src/app/shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-phonecall',
  templateUrl: './phonecall.component.html',
  styleUrls: ['./phonecall.component.scss']
})
export class PhonecallComponent implements OnInit {

  @Input() caseId: number = -1;
  @Input() caseTypeId?: number;
  @Input() phonecallObj?: any;


  addingPhoneCall: boolean = false;

  editNote = false;
  editingPhoneCall: boolean = false;

  phoneCallDetails = this.fb.group({
    callerType: [null, Validators.required],
    incoming: [true, Validators.required] ,
    notes: ['', Validators.required],
    addToOverview: [false]
  })


  constructor(
              public activeModal: NgbActiveModal,
              private fb: UntypedFormBuilder,
              public modalService: ModalService,
              private caseService: CaseService,
              private correspondenceTimelineService: CorrespondenceTimelineService) {  

  }

  ngOnInit() :void {
     if(this.phonecallObj == null)
    {

      Object.keys(this.phoneCallDetails.controls).forEach(key => {
        this.phoneCallDetails.get(key)!.markAsTouched();
        this.phoneCallDetails.get(key)!.updateValueAndValidity();
      });
    }
    else{
      this.editNote = true;
      this.caseId = this.phonecallObj.caseId;

      this.phoneCallDetails.controls['callerType'].patchValue(this.phonecallObj.callerType);
      this.phoneCallDetails.controls['callerType'].disable();
      this.phoneCallDetails.controls['incoming'].patchValue(this.phonecallObj.incoming);
      this.phoneCallDetails.controls['incoming'].disable();
      this.phoneCallDetails.controls['notes'].patchValue(this.phonecallObj.notes);
      //this.phoneCallDetails.controls['notes'].disable();
    }
  }

  addPhoneCall(){

    this.addingPhoneCall = true;

   const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
         
    modalRef.componentInstance.messageHeader = 'Is this very important information required in the Case Overview Screen?';
    modalRef.componentInstance.popupText1 = '';
    modalRef.componentInstance.popupText2 = '';

      modalRef.result.then(
        (result) => {
          if(result)
          {
            this.phoneCallDetails.controls['addToOverview'].patchValue(true);
          }

          this.caseService.addPhoneCall(this.caseId, this.phoneCallDetails.value).subscribe((response : any) => {

            this.activeModal.close(true);
            this.correspondenceTimelineService.refreshCaseTimeline.next();

            }, (error : any) => {

              var errorMessage = "Failed to add phone call";
              if(error.error !== null && error.error.message !== undefined)
              {
                errorMessage = error.error.message;
              }

            });

            },
            () => {
              // User clicked No or dismissed
              this.addingPhoneCall = false;
            }
      );
  }

  updatePhoneCall(){

    this.editingPhoneCall = true;

    this.caseService.editPhoneCall(this.caseId, this.phonecallObj.id, this.phoneCallDetails.value).subscribe((response : any) => {

      this.activeModal.close(true);
      this.correspondenceTimelineService.refreshCaseTimeline.next();

      }, (error : any) => {

        var errorMessage = "Failed to update phone call";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

      });
  }

  cancel(){
    this.activeModal.dismiss();
  }

}
